import React from 'react';
import {useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';

import Utility from '../../../../util/utilityfunctions';

import OutputText from '@ey/canvascoreservices/OutputText';

import Button from '../../../CoreWrappers/Button';
import Tooltip from '../../../CoreWrappers/Tooltip';
import StyledLinkTooltip from './StyledLinkTooltip';

const LinkTooltip = ({btnLabel, tooltipLabel, linkTo, variant}) => {
	const history = useHistory();

	const renderTrigger = () => {
		const props = {
			variant,
			onClick: () => history.push(linkTo),
			label: btnLabel,
			size: 'medium'
		};
 
		return <Button {...props} />;
	};

	const props = {
		trigger: renderTrigger(),
		placement: 'bottom',
		hideCloseButton: true,
		allowClick: false
	};

	return (
		<Tooltip {...props}>
			<StyledLinkTooltip>
				<OutputText body3>
					{Utility.createRichTextElement(tooltipLabel)}
				</OutputText>
			</StyledLinkTooltip>
		</Tooltip>
	);
};

LinkTooltip.propTypes = {
	btnLabel: PropTypes.string,
	tooltipLabel: PropTypes.string,
	linkTo: PropTypes.string,
	variant: PropTypes.string
};

LinkTooltip.defaultProps = {
	btnLabel: '',
	tooltipLabel: '',
	linkTo: '',
	variant: 'primary'
};

export default LinkTooltip;
